import { Checkbox, ListItemText, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface CompanyBalanceSelectorItemProps {
	fieldName: string;
	value: number[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	companyBalances: { id: number; value: string }[];
	error?: string;
}

export default function CompanyBalanceSelectorItem({
	fieldName,
	value = [],
	setValue,
	companyBalances,
	error,
}: CompanyBalanceSelectorItemProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-to-dos.${key}`);

	const handleChange = (event: SelectChangeEvent<number[]>) => {
		const selected = event.target.value as number[];

		setValue(fieldName, selected, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	const handleSelectAll = (selectAll: boolean) => {
		setValue(
			fieldName,
			selectAll ? companyBalances.map((companyBalance) => companyBalance.id) : [],
			{
				shouldValidate: true,
				shouldDirty: true,
			}
		);
	};

	return (
		<Select
			displayEmpty
			fullWidth
			multiple
			error={!!error}
			renderValue={(selected: unknown) =>
				Array.isArray(selected) && selected.length > 0
					? selected
							.map((id) => companyBalances.find((i) => i.id === id)?.value)
							.filter(Boolean)
							.join(", ")
					: ts("select-company-balance")
			}
			value={value}
			onChange={handleChange}
		>
			<MenuItem key="-1" value="-1">
				<Checkbox
					checked={value.length === companyBalances.length}
					sx={{ padding: "4px" }}
					onChange={() => handleSelectAll(value.length !== companyBalances.length)}
				/>
				<ListItemText primary={ts("select-all")} sx={{ "& span": { m: 0 } }} />
			</MenuItem>
			{companyBalances.map((companyBalance) => (
				<MenuItem
					key={companyBalance.id}
					sx={{ width: "100%", alignItems: "center", m: 0 }}
					value={companyBalance.id}
				>
					<Checkbox checked={value.includes(companyBalance.id)} sx={{ padding: "4px" }} />
					<ListItemText primary={companyBalance.value} sx={{ "& span": { m: 0 } }} />
				</MenuItem>
			))}
		</Select>
	);
}
